module.exports = require('./lib/emoji');


//////////////////
// WEBPACK FOOTER
// ./~/node-emoji/index.js
// module id = 973
// module chunks = 0